import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import style from './style.module.less';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { testId } from 'ui-components/services/testid-service';
import { loadMoreLabelQueBatches, setLabelQueBatchSelected } from '../../../../store/label-que/label-que.actions';
import Global from '../../../../store/global-selectors';
import LabelQueBatchTile from '../label-que-batch-tile';

const LabelQueBatches = () => {
  const dispatch = useDispatch();
  const onLoadMore = useCallback(() => {
    dispatch(loadMoreLabelQueBatches());
  }, [dispatch]);
  const onToggleBatchSelected = useCallback(
    (batchId) => {
      dispatch(setLabelQueBatchSelected(batchId));
    },
    [dispatch],
  );
  const batches = useSelector(Global.selectLabelQueBatches);
  const selectedBatches = useSelector(Global.selectLabelQueSelectedBatches);
  const isLabelFetchComplete = useSelector(Global.selectLabelQueIsLabelFetchingComplete);

  return (
    <div className={style['batch-que-wrapper']} {...testId('batch-que-wrapper')}>
      {batches.map((batch) => {
        const isSelected = selectedBatches.some((b) => b === batch.batchId);
        return (
          <LabelQueBatchTile
            key={batch.batchId}
            batch={batch}
            isSelected={isSelected}
            onToggleBatchSelected={() => onToggleBatchSelected(batch.batchId)}
          />
        );
      })}
      <div className={style['batch-que-pager']}>
        {!isLabelFetchComplete && (
          <Button onClick={onLoadMore} theme='link'>
            <FormattedMessage defaultMessage='Load more...' description='batchQue.seeMore' id='eQ4IZk' />
          </Button>
        )}
      </div>
    </div>
  );
};

export default LabelQueBatches;
